import Bar, { ActivityProps } from "../../shared/Activity/Bar";
import StackedBars from "./StackedBars";

export type SuiteActivityProps = ActivityProps & {
  passed_duration: number;
  failed_duration: number;
  humanFailedDuration: string;
  humanPassedDuration: string;
  humanSkippedDuration: string;
  humanUnknownDuration: string;
  humanPendingDuration: string;
  failed_execution_count: number;
  passed_execution_count: number;
  skipped_execution_count: number;
  pending_execution_count: number;
  unknown_execution_count: number;
};

type Props = {
  activities: Array<SuiteActivityProps>;
  wrapperHeight?: string;
};

const Activity = ({ activities, wrapperHeight = "75px" }: Props) => {
  if (activities.length === 0) {
    return null;
  }

  const calcMaxDuration = () => {
    if (activities.length === 0) {
      return 0;
    }

    const max = activities.reduce((prev, current) => {
      return prev.duration > current.duration ? prev : current;
    });

    return max.duration;
  };

  const maxDuration = calcMaxDuration();

  const bars = activities.map((activity) =>
    activity.result !== "pending" ? (
      <StackedBars
        key={activity?.id || Math.random().toString()}
        height={activity.duration / maxDuration}
        activity={activity}
      />
    ) : (
      <Bar key={activity.id} activity={activity} height={activity.duration / maxDuration} />
    ),
  );

  return (
    <div data-testid="chart">
      <div className="flex items-end justify-start" style={{ height: wrapperHeight }}>
        {bars}
      </div>
    </div>
  );
};

export default Activity;
